import { Directive, ElementRef, Injector} from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  selector: 'admin-user'
})
export class AdminUserDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('admin-user', elementRef, injector);
  }
}



// WEBPACK FOOTER //
// ./src/components/app/admin/user/admin-user/admin-user.directive.ts